export const SAVE_ALL_MAINTENANCE_TYPES = 'SAVE_ALL_MAINTENANCE_TYPES'
